import { withDefaults } from '@warp-drive/legacy/model/migration-support';

// inverse: null until match-plan declares the reciprocal matchPlanRetirementPlans relationship.
const MatchPlanRetirementPlanSchema = withDefaults({
  type: 'match-plan-retirement-plan',
  fields: [
    { kind: 'attribute', name: 'retirementPlan' },
    {
      kind: 'belongsTo',
      name: 'matchPlan',
      type: 'match-plan',
      options: { async: false, inverse: null },
    },
  ],
});

export default MatchPlanRetirementPlanSchema;
